<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-01-22 11:22:25
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-02-07 22:10:12
-->
<template>
  <el-dialog
    title="请输入操作密码"
    :visible.sync="isDialogShow"
    destroy-on-close
    width="500px"
    :before-close="onClose"
    append-to-body
    :close-on-click-modal="false"
  >
    <el-input type="password" v-model="password" show-password></el-input>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="onClose">取 消</el-button>
      <el-button size="mini" type="primary" @click="onSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ConfirmPassword",
  props: {
    isDialogShow: {
      type: Boolean,
    },
  },
  data() {
    return {
      password: "",
    };
  },
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    onSubmit() {
      if (this.password.length > 0) {
        this.$emit("onSubmit", this.password);
      } else {
        this.$message.warning("请输入操作密码");
      }
    },
  },
};
</script>

<style></style>
